/* eslint-disable react/no-array-index-key */
import React from 'react';
import {useQuery} from 'react-query';
import { UserService, OrderService } from '../../../../../support/services/api'
import Message from './Components/Message';
import Release from './Components/Release';
import ReleaseDonator from './Components/ReleaseDonator';
import QRCode from './Components/QRCode';
import QRCodeModal from './Components/QRCodeModal';
import CopyModal from './Components/CopyModal';
import Button from './Components/Button';
import styles from './Success.module.css';
import useModal from '../../../../../model/useModal';

function useSuccess(commands) {
  return ({
    eventHandlers: {

    },
    localStates: {

    },
  });
}

export default function Success(props) {
  const { commands, sharedStates } = props;
  const { localStates, eventHandlers } = useSuccess(commands);


  const { order, userId = '697f85b0', space } = sharedStates;
  

  const {sharedStates: copyModalStates, commands: copyModalCommands} = useModal();
  const {sharedStates: QRCodeModalStates, commands: QRCodeModalCommands} = useModal();

  const {
    data: user, isLoading, isIdle, isFetching,
  } = useQuery(
    ['user', userId],
    () => UserService().getByIds([userId]),
    {
      keepPreviousData: true,
      enabled: !!userId,
      select: (data) => (data.length ? data[0] : undefined),
    },
  );

  const spacePix = space?.payment?.bankInfo?.find((account)=>!!account.pixKey)?.pixKey;

  const {
    data: pix, isLoading: pixLoading, isIdle: pixIdle, isFetching: pixFetching,
  } = useQuery(
    ['pix', order.id],
    () => OrderService().getOrderPix(order.id),
    {
      keepPreviousData: true,
      enabled: (order.paymentMethod==='bank_transfer') && !!order.id && !!spacePix,
      select: (res) => res.pix,
    },
  );
    
  const {firstName, lastName, imagesPaths } = user;

  const userImage = imagesPaths[imagesPaths.length-1];

  return (
    <div className={styles.scroll}>
      <section className={styles.container}>
        <Message sharedStates={{donation: order.donationValue, id: order.id}}/>
        {sharedStates.order.donationValue
          ? <ReleaseDonator sharedStates={{firstName, lastName, space, userImage}}/>
          : <Release sharedStates = {{space}}/>}
        <QRCode sharedStates = {{paymentMethod: order.paymentMethod, spacePix}} commands={{copy:copyModalCommands, code:QRCodeModalCommands}}/>
        <Button sharedStates={{space}}/>
        <CopyModal sharedStates ={{...copyModalStates}} remoteStates={{pix}} commands={copyModalCommands} metaStates={{pixLoading, pixIdle, pixFetching}}/>
        <QRCodeModal sharedStates ={{...QRCodeModalStates}} remoteStates={{pix}} commands={QRCodeModalCommands} metaStates={{pixLoading, pixIdle, pixFetching}}/>
      </section>
    </div>
  );
}
